<template src="./dashboard.html">

</template>

<script>
import Vue from 'vue'
import ContextPage from '@/components/misc/context-page/ContextPage.vue'
import { authorizedOrganizationId, authorizedUserName, hasAdminClaim, hasUserManageClaim, hasUserReviewClaim, hasUserViewClaim, hasUserUpdateAllClaim, hasUserStatusUpdateClaim, hasUserStatusUpdateAllClaim, hasRoleViewClaim, hasRoleManageClaim, hasOrganizationViewClaim, hasProjectViewClaim, hasProjectManageClaim, hasProjectEvaluateClaim, hasProjectListViewClaim, hasProjectListManageClaim } from '@/router/auth'

export default {
  components: {
    ContextPage
  },
  data () {
    return {
      pageLoader: false,
      organization: {},
      help: {
        root: Vue.$helpConfig.dashboard
      }
    }
  },
  computed: {
    displayAdministrationMenu () {
      return hasAdminClaim() || hasOrganizationViewClaim() || hasRoleViewClaim() || hasRoleManageClaim() || hasUserReviewClaim() || hasUserManageClaim() || hasUserViewClaim() || hasUserUpdateAllClaim() || hasUserStatusUpdateClaim() || hasUserStatusUpdateAllClaim()
    },
    displayProjectMenu () {
      return hasAdminClaim() || hasProjectViewClaim() || hasProjectManageClaim() || hasProjectEvaluateClaim()
    },
    displayProjectListMenu () {
      return hasAdminClaim() || hasProjectListViewClaim() || hasProjectListManageClaim()
    },
    organizationId () {
      return authorizedOrganizationId()
    },
    userName () {
      return authorizedUserName()
    },
    displayRegistryMenu () {
      return true
    },
    displayBoardReportsMenu () {
      return hasAdminClaim()
    },
    displayArchivedReports () {
      return hasAdminClaim()
    }
  },
  created () {
    this.setupPage()
  },
  methods: {
    setupPage () {
      this.pageLoader = true
      this.$http.get(Vue.$apiConfig.organizationDetailsGet + '/' + this.organizationId).then(
        response => {
          this.organization = response.data.payload
          this.pageLoader = false
        },
        error => {
          this.formatErrorResponse(error)
          this.pageLoader = false
        }
      )
    }
  }
}
</script>
